import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

import { computed, onMounted, ref, watchEffect } from "vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { useNgSession } from "@sazka/ng/ng-session";
import { MediaPreloader } from "@sazka/utils/media-preloader";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import BonusomatAutomatCylinder from "./bonusomat-automat-cylinder.vue";
import { fetchAutomatCylinderImages } from "../../../api/bonusomat-player-data-api";
import { SpinAutomatState } from "../../../models/bonusomat-spin-types";
import { bonImgUrl } from "../../../utils/image-src";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-spin-automat',
  props: {
    state: {},
    winIcons: {}
  },
  emits: ["spinStopped"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const isMovSupported = ResponsiveUtils.isMovSupported();
const isIos = ResponsiveUtils.isIos();
const isSafari = ResponsiveUtils.isSafari();

const defaultAnimationRef = ref<HTMLVideoElement>();
const rollingAnimationRef = ref<HTMLVideoElement>();
const winningAnimationRef = ref<HTMLVideoElement>();

const additionalClass = ref("");

const { session } = useNgSession();

const iconsUrls = ref<string[]>([]);
const init = async () => {
    iconsUrls.value = (await fetchAutomatCylinderImages(session.value?.PlayerID))?.icons ?? [];
    Loader.hide();
};

Loader.show();
init();

const showDefaultAnimation = computed(
    () => props.state != "ROLLING" && props.state != "STOPPING" && props.state != "WINNING"
);
const showRollingAnimation = computed(() => props.state == "ROLLING" || props.state == "STOPPING");
const showWinningAnimation = computed(() => props.state == "WINNING");

onMounted(() => {
    watchEffect(() => {
        if (showDefaultAnimation.value) {
            defaultAnimationRef.value.play();
            if (isIos || isSafari) {
                defaultAnimationRef.value.onloadeddata = () =>
                    setTimeout(() => {
                        additionalClass.value = "bonusomat-spin-automat--ios-loaded";
                    }, 0);
            }
        } else if (showRollingAnimation.value) {
            rollingAnimationRef.value.play();
        } else if (showWinningAnimation.value) {
            winningAnimationRef.value.play();
        }
    });
});

let stopCounter = 0;
const cylinderSpinEndHandler = () => {
    stopCounter++;
    if (props.winIcons.length == stopCounter) {
        emit("spinStopped");
        stopCounter = 0;
    }
};

const automatRollingMovSrc = bonImgUrl("automat/automat-rolling", "mov");
const automatRollingWebmSrc = bonImgUrl("automat/automat-rolling", "webm");
const automatWinMovSrc = bonImgUrl("automat/automat-win", "mov");
const automatWinWebmSrc = bonImgUrl("automat/automat-win", "webm");
const preloadVideos = () => {
    if (isMovSupported) {
        MediaPreloader.preloadVideos([automatRollingMovSrc, automatWinMovSrc]);
    } else {
        MediaPreloader.preloadVideos([automatRollingWebmSrc, automatWinWebmSrc]);
    }
};
watchEffect(() => {
    if (props.state == "ACTIVE") {
        preloadVideos();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bonusomat-spin-automat", additionalClass.value])
  }, [
    (iconsUrls.value.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.winIcons, (winIcon, index) => {
          return (_openBlock(), _createBlock(BonusomatAutomatCylinder, {
            key: index,
            class: _normalizeClass(["bonusomat-spin-automat__cylinder", `bonusomat-spin-automat__cylinder--${index}`]),
            "icons-urls": iconsUrls.value,
            state: _ctx.state,
            "win-icon": winIcon,
            "spin-end-delay": 350 * index,
            onSpinEnd: cylinderSpinEndHandler
          }, null, 8, ["class", "icons-urls", "state", "win-icon", "spin-end-delay"]))
        }), 128))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("video", {
      ref_key: "defaultAnimationRef",
      ref: defaultAnimationRef,
      alt: "Automat je aktivní",
      loop: "",
      muted: "",
      constrols: "false",
      playsinline: "",
      autoplay: "",
      preload: "auto",
      class: "bonusomat-spin-automat__video"
    }, [
      (_unref(isMovSupported))
        ? (_openBlock(), _createElementBlock("source", {
            key: 0,
            src: _unref(bonImgUrl)('automat/automat-active', 'mov'),
            type: "video/quicktime"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("source", {
        src: _unref(bonImgUrl)('automat/automat-active', 'webm'),
        type: "video/webm"
      }, null, 8, _hoisted_2)
    ], 512), [
      [_vShow, showDefaultAnimation.value]
    ]),
    _withDirectives(_createElementVNode("video", {
      ref_key: "rollingAnimationRef",
      ref: rollingAnimationRef,
      alt: "Automat se točí",
      muted: "",
      constrols: "false",
      playsinline: "",
      preload: "auto",
      class: "bonusomat-spin-automat__video"
    }, [
      (_unref(isMovSupported))
        ? (_openBlock(), _createElementBlock("source", {
            key: 0,
            src: _unref(automatRollingMovSrc),
            type: "video/quicktime"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("source", {
        src: _unref(automatRollingWebmSrc),
        type: "video/webm"
      }, null, 8, _hoisted_4)
    ], 512), [
      [_vShow, showRollingAnimation.value]
    ]),
    _withDirectives(_createElementVNode("video", {
      ref_key: "winningAnimationRef",
      ref: winningAnimationRef,
      alt: "Automat vyhrává",
      loop: "",
      muted: "",
      constrols: "false",
      playsinline: "",
      preload: "auto",
      class: "bonusomat-spin-automat__video"
    }, [
      (_unref(isMovSupported))
        ? (_openBlock(), _createElementBlock("source", {
            key: 0,
            src: _unref(automatWinMovSrc),
            type: "video/quicktime"
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("source", {
        src: _unref(automatWinWebmSrc),
        type: "video/webm"
      }, null, 8, _hoisted_6)
    ], 512), [
      [_vShow, showWinningAnimation.value]
    ])
  ], 2))
}
}

})